import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { latestDate } from "../../../../sharedComponent/common";
import CommonDatePicker from "../../../../sharedComponent/CommonDatePicker";
import Import from "../../../../assets/images/ic-Import.svg";
import ApiConfig from "../../../../api/ApiConfig";
import { getWithAuthCall, simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

const AlertsReport = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [VehicleId, setVehicleId] = useState("");
  const [alertType, setAlertType] = useState("");
  const [severity, setSeverity] = useState("");
  const [startDate, setStartDate] = useState({ toDayDate: new Date() });
  const [endDate, setEndDate] = useState({ toDayEnd: new Date() });
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);
  const maxDate = new Date();

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    getVehicleList();
  }, []);

  function getVehicleList() {
    getWithAuthCall(ApiConfig.VEHICEL_AVALIVALITY_DROPDAWAN)
      .then((data) => setVehicleList(data?.data || []))
      .catch((err) => console.log("api err", err));
  }

  useEffect(() => {
    fetchReport();
  }, [VehicleId, alertType, severity, startDate, endDate, OptionDownload]);

  /* === GREEN :: API INTEGRATED === */
  const fetchReport = () => {
    const body = {
      format: OptionDownload,
      vehicle_id: VehicleId,
      startdate: latestDate(startDate.toDayDate, "yyyy-MM-dd"),
      enddate: latestDate(endDate.toDayEnd, "yyyy-MM-dd"),
      // wire the Alert Type and Severity filters into the request
      alert_type: alertType,
      severity: severity,
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(ApiConfig.ALERTS_REPORT, JSON.stringify(body))
      .then((res) => {
        if (res?.result) {
          const raw = res?.listData || [];
          const flat = Array.isArray(raw[0]) ? raw.flat() : raw;
          setOrderListData(flat);
        } else {
          setOrderListData([]);
        }
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>
                    {t("From:")} {latestDate(startDate.toDayDate, "yyyy-MM-dd")} -{" "}
                    {t("To:")} {latestDate(endDate.toDayEnd, "yyyy-MM-dd")}
                  </p>
                </p>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Vehicle list")}
                  onChange={(value) => setVehicleId(value)}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toString().toLowerCase().includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Vehicle")}
                  </Option>
                  {vehicleList?.map((vehicle) => (
                    <Option
                      key={vehicle.vehicle_id}
                      value={vehicle.vehicle_id}
                      label={vehicle.vehicle_number}
                      style={{ color: "rgba(156, 73, 0)" }}
                    >
                      {vehicle.vehicle_number}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Alert Type")}
                  value={alertType}
                  onChange={(value) => setAlertType(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Alert Type")}
                  </Option>
                  <Option value="overspeed" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Over Speed")}
                  </Option>
                  <Option value="harsh_brake" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Harsh Brake")}
                  </Option>
                  <Option value="harsh_acceleration" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Harsh Acceleration")}
                  </Option>
                  <Option value="geofence" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Geofence Violation")}
                  </Option>
                  <Option value="device_offline" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Device Offline")}
                  </Option>
                  <Option value="sos" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("SOS")}
                  </Option>
                </Select>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "130px" }}
                  className="custom-select"
                  placeholder={t("Severity")}
                  value={severity}
                  onChange={(value) => setSeverity(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("All")}
                  </Option>
                  <Option value="critical" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Critical")}
                  </Option>
                  <Option value="high" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("High")}
                  </Option>
                  <Option value="medium" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Medium")}
                  </Option>
                  <Option value="low" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Low")}
                  </Option>
                </Select>
              </div>

              <div className="innerSelectBox weekCounter datepicker-main">
                <CommonDatePicker
                  dateKey={"toDayDate"}
                  setDate={setStartDate}
                  data={startDate}
                  SetPlaceholder={t("Start Date")}
                  dataDisbal={maxDate}
                />
              </div>
              <div className="innerSelectBox weekCounter datepicker-main">
                <CommonDatePicker
                  dateKey={"toDayEnd"}
                  setDate={setEndDate}
                  data={endDate}
                  SetPlaceholder={t("End Date")}
                  dataDisbal={maxDate}
                />
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* === GREEN :: API INTEGRATED (table fields mapped to API response) === */}
            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("Vehicle Number")}</th>
                  <th>{t("Device IMEI")}</th>
                  <th>{t("Alert Type")}</th>
                  <th>{t("Alert Status")}</th>
                  <th>{t("Alert Value")}</th>
                  <th>{t("Alert Date")}</th>
                  <th>{t("Alert Time")}</th>
                  <th>{t("Latitude")}</th>
                  <th>{t("Longitude")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {OrderListData && OrderListData?.length > 0
                    ? OrderListData.map((item, index) => (
                        <tr className="text-center" key={index}>
                          <td>{index + 1}</td>
                          <td>{item.vehicle_number}</td>
                          <td>{item.vehicle_imei}</td>
                          <td>{item.alert_type}</td>
                          <td>{item.alert_status}</td>
                          <td>{item.alert_value}</td>
                          <td>{item.logged_date}</td>
                          <td>{item.logged_time}</td>
                          <td>
                            {item.latitude} {item.latitude_direction}
                          </td>
                          <td>
                            {item.longitude} {item.longitude_direction}
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AlertsReport;
